.ant-layout-header{font-weight:600;font-size:20px;background-color:#f4f4f6;background:#f4f4f6}nz-content{padding-left:50px;padding-right:50px}.eoc-section{padding-top:64px}.eoc-section.eoc-section-discharge-report{padding-top:0}
/*# sourceMappingURL=eoc-section.component-ZUXHTGSB.css.map */
